export default function formatKey(s) {
  if (typeof s !== "string") return s;
  return s
    .replace(/^[\s_]+|[\s_]+$/g, "")
    .replace(/[_\s]+/g, " ")
    .replace(/\-/g, " ")
    .replace(/^[a-z]/, function (m) {
      return m.toUpperCase();
    });
}
